<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-table-header">
          <div class="title-container">
            <h3 class="title">
              Finance reports - payrolls
              <div
                class="spinner-border spinner-theme_default"
                role="status"
                v-if="isDataPageLoading"
              >
                <span class="sr-only">
                  Loading...
                </span>
              </div>
            </h3>
            <div>
              <b-button
                class="button"
                :variant="isShowFilter ? 'secondary' : 'info'"
                @click="toggleShowFilter"
              >
                <span class="material-icons icon-image-preview">
                  tune
                </span>
                Filters
              </b-button>
            </div>
          </div>
          <Filters
            v-show="isShowFilter"
            textButtonSubmit="Get Report"
            :data="filters"
            :isLoading="isDataPageLoading"
            @submit="getReportsPayrolls"
          />

          <TableForPage
            ref="table"
            style="margin-bottom: 0;"
            v-if="reports.length"
            :tableData="reports"
            :fields="fieldsReports"
            :slots="slotReports"
            :totalItems="totalReports"
            :totalFields="fieldsReportsTotal"
            :tableDescription="columnDescription"
            showTopControls
            :showTotalTable="true"
          >
            <template v-slot:specialist="slotProps">
              <div class="specialist-user-name">
                {{ slotProps.item.user.name }}
              </div>
              <div class="specialist-user-position">
                {{ slotProps.item.user.position }}
              </div>
            </template>
            <template v-slot:row="slotProps">
              <NestedTable
                style="margin-bottom: 0;"
                :items="slotProps.row.item.periods"
                :fields="fieldsReportsPeriods"
                :perPage="slotProps.row.item.periods.length"
                :buttonShow="false"
                :showPagination="false"
              >
              </NestedTable>
            </template>
          </TableForPage>

          <!--<ReportTable
            style="margin-bottom: 0;"
            v-if="reports.length"
            :items="reports"
            :fields="fieldsReports"
            :totalItems="totalReports"
            :totalFields="fieldsReportsTotal"
            :description="columnDescription"
            showTopControls
          >
            <template v-slot:row="slotProps">
              <ReportTable
                style="margin-bottom: 0;"
                class="report-table report-table__total"
                :items="slotProps.row.item.periods"
                :fields="fieldsReportsPeriods"
                :perPage="slotProps.row.item.periods.length"
                :buttonShow="false"
                :showPagination="false"
              >
              </ReportTable>
            </template>
          </ReportTable>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { permissions } from '@mocks/permissions'
import Filters from '@components/Filter/Filter'
import TableForPage from '@tables/TableForPage'
import NestedTable from '@tables/NestedTable'
import moment from 'moment'

export default {
  components: {
    Filters,
    TableForPage,
    NestedTable
  },
  data () {
    return {
      permissions: permissions,
      isDataPageLoading: false,
      isShowFilter: true,
      filters: {
        'date_from': {
          type: 'datepicker',
          name: 'date_from',
          label: 'Date from',
          format: 'dd/MM/yyyy',
          validation: [
            { name: 'required' }
          ],
          value: new Date(moment().subtract(1, 'months').startOf('month')),
          class: 'col-md-3'
        },
        'date_to': {
          type: 'datepicker',
          name: 'date_to',
          label: 'Date to',
          format: 'dd/MM/yyyy',
          validation: [
            { name: 'required' }
          ],
          value: new Date(moment().subtract(1, 'months').endOf('month')),
          class: 'col-md-3'
        },
        'users': {
          type: 'multiselect',
          name: 'users',
          nameItem: 'user_id',
          label: 'Users',
          valueField: 'id',
          selectLabel: 'name',
          options: [],
          value: [],
          class: 'col-md-3'
        }
      },
      slotReports: {
        specialist: {
          name: 'specialist'
        }
      },
      fieldsReports: [
        {
          key: 'specialist',
          label: 'Specialist',
          class: 'column-bd-name',
          sortable: false
        },
        /* {
          key: 'user.name',
          label: 'Name',
          sortable: true,
          class: 'column-bd-name'
        },
        {
          key: 'user.position',
          label: 'Position',
          sortable: true,
          class: 'column-project-name'
        }, */
        {
          key: 'date_from',
          label: 'Date from',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'date_to',
          label: 'Date to',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'days_amount',
          label: 'Days amount',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'day_cost.UAH',
          label: 'Day UAH',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'day_cost.USD',
          label: 'Day USD',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'day_cost.EUR',
          label: 'Day EUR',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'equivalent.UAH',
          label: 'Period UAH',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'equivalent.USD',
          label: 'Period USD',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'equivalent.EUR',
          label: 'Period EUR',
          sortable: true,
          class: 'column-date'
        },

        {
          key: 'more',
          label: 'More',
          class: 'column-more'
        }
      ],
      fieldsReportsPeriods: [
        /* {
          key: 'date_from',
          label: 'Date from',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'date_to',
          label: 'Date to',
          sortable: true,
          class: 'column-date'
        }, */
        {
          key: 'days_amount',
          label: 'Days amount',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'day_costUAH',
          label: 'Day UAH',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'day_costUSD',
          label: 'Day USD',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'day_costEUR',
          label: 'Day EUR',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'period_costUAH',
          label: 'Period UAH',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'period_costUSD',
          label: 'Period USD',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'period_costEUR',
          label: 'Period EUR',
          sortable: true,
          class: 'column-date'
        }
      ],
      fieldsReportsTotal: [
        {
          key: 'total_name',
          label: 'Name',
          sortable: true,
          class: 'column-bd-name'
        },
        /* {
          key: 'user.position',
          label: 'Position',
          sortable: true,
          class: 'column-project-name'
        }, */
        {
          key: 'date_from',
          label: 'Date from',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'date_to',
          label: 'Date to',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'days_amount',
          label: 'Days amount',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'day_cost.UAH',
          label: 'Day UAH',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'day_cost.USD',
          label: 'Day USD',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'day_cost.EUR',
          label: 'Day EUR',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'equivalent.UAH',
          label: 'Period UAH',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'equivalent.USD',
          label: 'Period USD',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'equivalent.EUR',
          label: 'Period EUR',
          sortable: true,
          class: 'column-date'
        },

        {
          key: 'more',
          label: 'More',
          sortable: true,
          class: 'column-more'
        }
      ],
      reports: [],
      totalReports: [],
      columnDescription: [
        '<strong>Position</strong> = ',
        '<strong>Day UAH</strong> = ',
        '<strong>Period UAH</strong> = '
      ]
    }
  },
  computed: {
    ...mapGetters({
      getAllUsers: 'getAllUsers'
    })
  },
  created () {
    this.fetchAllData()
  },
  methods: {
    toggleShowFilter () {
      this.isShowFilter = !this.isShowFilter
    },
    fetchAllData () {
      Promise.all([
        this.fetchAllUsers()
      ])
        .then(() => {
          this.setAllOptionsFilter()
        })
    },
    resetPagination () {
      this.$refs['table'] && this.$refs['table'].resetPagination()
    },
    getReportsPayrolls (fields) {
      const data = this.prepareDataForGetReports(fields)

      this._toggleDataPageLoading(() => {
        return this.$api.finances.getReportsPayrolls(data).then((res) => {
          res.data.total.total_name = 'Total:'
          this.reports = res.data.usersTotal
          this.totalReports = [res.data.total]

          this.resetPagination()
        })
      })
    },
    async fetchAllUsers () {
      return this.$api.users.getAllUsers()
    },
    setAllOptionsFilter () {
      this.filters.users.options = this.getAllUsers
    },
    prepareDataForGetReports (fields) {
      let newFields = fields
      let data = {}

      newFields.date_from.value = this._toLocalTime(newFields.date_from.value)
      newFields.date_to.value = this._toLocalTime(newFields.date_to.value)

      for (let key in fields) {
        const name = fields[key]['name']
        let value = fields[key]['value']

        if (Array.isArray(value)) {
          value = value.map(item => {
            return {
              [fields[key].nameItem]: item.id
            }
          })
        }

        data[name] = value
      }

      return data
    }
  }
}

</script>

<style lang="scss">
  .report-table-total{
    thead{
      display: none;
    }
  }
</style>
